export enum SelectionActionType {
  SET_SELECTED_CLIENTS = `SET_SELECTED_CLIENTS`,
  SET_SELECTED_VEHICLES = `SET_SELECTED_VEHICLES`,
  SET_ACTIVE_PLAN_SELECTED_DRIVERS = `SET_ACTIVE_PLAN_SELECTED_DRIVERS`,
  SET_ACTIVE_PLAN_SELECTED_STOPS = `SET_ACTIVE_PLAN_SELECTED_STOPS`,
  SET_SELECTED_SUPERVISORS = `SET_SELECTED_SUPERVISORS`,
  ON_SELECT_STOP = `ON_SELECT_STOP`,
  ON_SELECT_DRIVER = `ON_SELECT_DRIVER`,
}

export interface SetSelectedClientsAction {
  type: SelectionActionType.SET_SELECTED_CLIENTS;
  payload: {
    selectedClients: Array<string>;
  };
}

export interface SetSelectedVehiclesAction {
  type: SelectionActionType.SET_SELECTED_VEHICLES;
  payload: {
    selectedVehicles: Array<string>;
  };
}

export interface SetActivePlanSelectedDriversAction {
  type: SelectionActionType.SET_ACTIVE_PLAN_SELECTED_DRIVERS;
  payload: {
    selectedDrivers: Array<string>;
  };
}

export interface SetActivePlanSelectedStopsAction {
  type: SelectionActionType.SET_ACTIVE_PLAN_SELECTED_STOPS;
  payload: {
    selectedStops: Array<string>;
  };
}

export interface SetSelectedSupervisorsAction {
  type: SelectionActionType.SET_SELECTED_SUPERVISORS;
  payload: {
    selectedSupervisors: Array<string>;
  };
}

export interface OnSelectStopAction {
  type: SelectionActionType.ON_SELECT_STOP;
  payload: {
    stopId: string;
    withControlKey?: boolean;
  };
}

export interface OnSelectDriverAction {
  type: SelectionActionType.ON_SELECT_DRIVER;
  payload: {
    driverId: string;
    withControlKey?: boolean;
  };
}

export type SelectionActions =
  | SetSelectedClientsAction
  | SetSelectedVehiclesAction
  | SetActivePlanSelectedDriversAction
  | SetActivePlanSelectedStopsAction
  | SetSelectedSupervisorsAction
  | OnSelectStopAction
  | OnSelectDriverAction;
